import { render } from "./PosEvents.vue?vue&type=template&id=71e5a3d9"
import script from "./PosEvents.vue?vue&type=script&lang=js"
export * from "./PosEvents.vue?vue&type=script&lang=js"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__